import { BulkButtonSelect } from '@bo-components/common/BulkButtonSelect';

export const IsFinalSelect = ({
  containerClassName = '',
  className = '',
  label,
  onChange,
  value,
  zIndex = undefined
}: {
  containerClassName?: string;
  className?: string;
  label: string;
  onChange: (value: string) => void;
  value: string;
  zIndex?: number;
}) => {
  return (
    <BulkButtonSelect
      containerClassName={containerClassName}
      className={className}
      label={label}
      onChange={onChange}
      value={value}
      zIndex={zIndex}
      options={['Disable', 'Enable']}
      labelSuffix="is final"
    />
  );
};
